import React from "react";
import "./index.css";
import footerlogo from "../../assets/footerlogo.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__logo">
        <img src={footerlogo} alt="Logo" />
      </div>

      <div className="footer__links">
        <a
          href="https://instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__btn"
        >
          Instagram
        </a>
        <a
          href="https://wa.me/77001234567"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__btn"
        >
          WhatsApp
        </a>
      </div>
    </footer>
  );
}

export default Footer;
